import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../Styles/GenerateInvoice.css";
import Header from "../Header";
import VertNav from "../VertNav";
import { FaRegCommentDots, FaTimes } from "react-icons/fa";
import Select from "react-select";
import config from "../../../config";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation } from "react-router-dom";
import CustomerSummary from "./CustomerSummary";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function getCurrentDate() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
}

function GenerateInvoice() {
    const navigate = useNavigate();

    const [categoryServices, setCategoryServices] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [customer_name, setCustomer_Name] = useState("");
    const [email, setEmail] = useState("");
    const [mobile_no, setMobileNo] = useState("");
    const [address, setAddress] = useState("");
    const [service_by, setServiceBy] = useState([]);
    const [service, setService] = useState([]);
    const [staff, setStaff] = useState([]);
    const [isGST, setIsGST] = useState(false);
    const [gst_number, setGSTNumber] = useState("");
    const [comments, setComments] = useState("");
    const [servicesTableData, setServicesTableData] = useState([]);
    const [inputFieldValue, setInputFieldValue] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasFetchedServicesCategory, setHasFetchedServicesCategory] =
        useState(false);
    const [hasFetchedProducts, setHasFetchedProducts] = useState(false);
    const [selectedList, setSelectedList] = useState([]); // Initialize selectedList as an empty array
    const [selectedCategoryValues, setSelectedCategoryValues] = useState([]); // Initialize selectedList as an empty array
    const [selectedServiceValues, setSelectedServiceValues] = useState([]);
    const [productList, setProductList] = useState([]);

    const [isServiceModalOpen, setServiceModalOpen] = useState(false);
    const [isProductModalOpen, setProductModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchQuery2, setSearchQuery2] = useState("");

    const [selectedServices, setSelectedServices] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteInvoiceId, setDeleteInvoiceId] = useState(null);
    const [anniversaryDate, setAnniversaryDate] = useState(null);

    const [userExists, setUserExists] = useState(null);
    const [membershipOptions, setMembershipOptions] = useState(false);
    const [selectMembership, setSelectMembership] = useState("");
    const [couponOptions, setCouponOptions] = useState([]);
    const [selectedCoupons, setSelectedCoupons] = useState([]);
    const [selectCoupon, setSelectCoupon] = useState("");
    const [userId, setUserId] = useState(null);
    const modalRef = useRef(null);
    const [isMembershipStaffModalOpen, setIsMembershipStaffModalOpen] =
        useState(false);
    const [isCouponStaffModalOpen, setIsCouponStaffModalOpen] = useState(false);
    const [selectedCouponIndex, setSelectedCouponIndex] = useState(null);
    const [membershipStaff, setMembershipStaff] = useState([]);
    const [couponStaff, setCouponStaff] = useState([]);
    const location = useLocation();
    const { appointment, invoiceData, isEditMode } = location.state || {};
    // Close modal on outside click
    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setServiceModalOpen(false);
            setProductModalOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [dialogOpen, setDialogOpen] = useState(false); // State for dialog visibility
    const [dialogTitle, setDialogTitle] = useState(""); // State for dialog title
    const [dialogMessage, setDialogMessage] = useState(""); // State for dialog message
    const branchName = localStorage.getItem("branch_name");
    const sname = localStorage.getItem("s-name");
    const [InvoiceId, setInvoiceId] = useState("");
    const [product_value, setProductValue] = useState([]);
    const [productData, setProductData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [staffData, setStaffData] = useState([]);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [customerData, setCustomerData] = useState(null);
    const [apiCalled, setApiCalled] = useState(false);
    const [staffApiCalled, setStaffApiCalled] = useState(false);
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [genderFilter, setGenderFilter] = useState([]); // Default is no filter
    const bid = localStorage.getItem("branch_id");
    const token = localStorage.getItem("token");
    const [popupData, setPopupData] = useState(null);
    const [data, setData] = useState(null);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const fetchCustomerData = async () => {
        try {
            const response = await axios.get(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${bid}`,
                {
                    headers: { Authorization: `Token ${token}` },
                }
            );
            if (response.data.status) {
                setData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching customer data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomerData();
    }, []);
    const handleNameChange = (e) => {
        const inputValue = e.target.value;
        const formatted = inputValue.replace(/\b\w/g, (char) =>
            char.toUpperCase()
        );
        setCustomer_Name(formatted);

        // Filter customers based on input
        if (inputValue.length > 0 && data) {
            // Added null check for data
            const filtered = data.filter((customer) =>
                customer.name
                    ?.toLowerCase()
                    .startsWith(inputValue.toLowerCase())
            );
            setFilteredCustomers(filtered);
            setShowDropdown(true);
        } else {
            setFilteredCustomers([]);
            setShowDropdown(false);
        }
    };
    const handleCustomerSelect = (customer) => {
        setCustomer_Name(customer.name);
        setMobileNo(customer.mobile_no || ""); // Assuming phone_number is the field
        setSelectedCustomer(customer);
        setShowDropdown(false);
    };
    const fetchData = async () => {
        try {
            if (apiCalled) return; // Prevent duplicate API calls

            const branchName = localStorage.getItem("branch_name");
            const token = localStorage.getItem("token");

            if (!branchName || !token) {
                console.error("Branch name or token is missing.");
                return;
            }

            const response = await fetch(
                `${config.apiUrl}/api/swalook/inventory/product/?branch_name=${bid}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch products: ${response.statusText}`
                );
            }

            const result = await response.json();

            if (!result.status || !Array.isArray(result.data)) {
                throw new Error("Invalid API response format");
            }

            // Transform API response into a structured category-product map
            const categoryMap = new Map();

            result.data.forEach((product) => {
                if (product.stocks_in_hand <= 0) return; // 🚫 Skip products with no stock
                const categoryName =
                    product.category_details?.product_category ||
                    "Uncategorized";

                if (!categoryMap.has(categoryName)) {
                    categoryMap.set(categoryName, {
                        key: categoryName,
                        value: categoryName,
                        products: [],
                    });
                }
                // //console.log("check", categoryMap,product)
                categoryMap.get(categoryName).products.push({
                    id: product.id,
                    name: product.product_name || "Unnamed Product",
                    price: product.product_price || 0,
                    quantity: 1,
                    staff: [],
                    note: "No notes added",
                    category: categoryName,
                    stock: product.stocks_in_hand, // Added stock information
                    unit: product.unit || "", // Added unit information
                    expiryDate: product.expiry_date, // Added expiry date
                });
            });

            const categories = Array.from(categoryMap.values());

            setProductCategory(categories);
            setHasFetchedProducts(true);
        } catch (error) {
            console.error("Error fetching products:", error.message);
        }
    };

    const fetchStaffData = async () => {
        try {
            if (staffApiCalled) return; // Prevent redundant API calls

            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token is missing.");
                return;
            }

            const response = await fetch(
                `${config.apiUrl}/api/swalook/staff/?branch_name=${bid}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                console.error(
                    `API Error: ${response.status} - ${response.statusText}`
                );
                return;
            }

            const data = await response.json();
            const staffArray = Array.isArray(data.table_data)
                ? data.table_data
                : [];

            // Format staff data
            const formattedOptions = staffArray.map((staff) => ({
                label: `${staff.staff_data.staff_name})`,
            }));

            setStaffData(formattedOptions);
            setStaffApiCalled(true); // Mark API as called
        } catch (error) {
            console.error("Error fetching staff data:", error);
            setStaffData([]); // Reset staff data on error
        }
    };

    const fetchServiceCategoryData = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${config.apiUrl}/api/swalook/table/services/?branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch categories: ${response.statusText}`
                );
            }

            const result = await response.json();

            if (!result.status || !Array.isArray(result.data)) {
                throw new Error("Invalid API response format");
            }

            // Transform API response into a structured category-service map
            const categoryMap = new Map();

            result.data.forEach((categoryData) => {
                const categoryName =
                    categoryData.category_name || "Uncategorized";

                // If the category doesn't exist yet, create an entry for it
                if (!categoryMap.has(categoryName)) {
                    categoryMap.set(categoryName, {
                        key: categoryName,
                        value: categoryName,
                        services: [],
                    });
                }

                const category = categoryMap.get(categoryName);

                // Process regular services
                if (
                    categoryData.services &&
                    Array.isArray(categoryData.services)
                ) {
                    categoryData.services.forEach((service) => {
                        category.services.push({
                            id: service.id,
                            name: service.service || "Unnamed Service",
                            price: service.service_price || 0,
                            duration: service.service_duration || 0,
                            for_men: service.for_men,
                            for_women: service.for_women,
                            quantity: 1,
                            staff: [],
                            note: "No notes added",
                            category: categoryName,
                            type: "service",
                        });
                    });
                }

                // Process combos - treat them as services for display purposes
                if (categoryData.combos && Array.isArray(categoryData.combos)) {
                    categoryData.combos.forEach((combo) => {
                        // Extract service names from the combo
                        const serviceNames =
                            combo.services && Array.isArray(combo.services)
                                ? combo.services
                                      .map(
                                          (service) =>
                                              service.service ||
                                              "Unnamed Service"
                                      )
                                      .join(", ")
                                : "No services listed";

                        category.services.push({
                            id: `combo-${combo.combo_name}`,
                            name: combo.combo_name,
                            price: combo.combo_price || 0,
                            duration: combo.duration || 0,
                            for_men: true, // Combos typically available for both
                            for_women: true,
                            quantity: 1,
                            staff: [],
                            note: "No notes added",
                            category: categoryName,
                            type: "combo",
                            isCombo: true,
                            comboData: combo, // Store original combo data for reference
                            serviceNames: serviceNames, // Store service names for display
                        });
                    });
                }
            });

            // Convert the categoryMap to an array
            const categories = Array.from(categoryMap.values());

            // Log the structured categories for debugging
            //console.log("Structured categories:", categories);

            setCategoryServices(categories);
            setHasFetchedServicesCategory(true);
        } catch (error) {
            console.error("Error fetching categories:", error.message);
        }
    };

    const handleServiceToggle = (isChecked, service) => {
        setSelectedServices((prev) =>
            isChecked
                ? [...prev, service]
                : prev.filter((s) => s.id !== service.id)
        );
    };

    const finalizeSelection = () => {
        //console.log("Selected Services:", selectedServices);
    };

    // Handle category click (Fetch if not already fetched)
    const handleServiceCategoryClick = () => {
        if (!hasFetchedServicesCategory) fetchServiceCategoryData();
    };

    // Handle category selection
    const handleCategorySelect = (selectedCategories) => {
        setSelectedCategoryValues(selectedCategories);

        const updatedCategoryList = selectedCategories.map((category) => ({
            ...category,
            services: category.services || [],
            isActive: true,
            note: "No note added",
        }));
    };

    // Handle gender filter toggle
    const handleGenderFilterToggle = (gender, isChecked) => {
        setGenderFilter((prevFilter) => {
            if (isChecked) {
                return [...prevFilter, gender];
            } else {
                return prevFilter.filter((g) => g !== gender);
            }
        });
    };

    const filteredCategories = categoryServices.filter(
        (category) =>
            category.value?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            category.services.some((service) =>
                service.name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
    );
    const filteredproduct = productCategory.filter((category, index) => {
        const search = searchQuery2.toLowerCase();

        const valueMatch = category?.value?.toLowerCase().includes(search);

        if (!Array.isArray(category?.products)) {
            console.warn(
                `⚠️ category.products is not an array or is undefined at index ${index}`,
                category.products
            );
        }

        const productMatch =
            Array.isArray(category?.products) &&
            category.products.some((product, pIndex) => {
                return product?.name?.toLowerCase().includes(search);
            });

        return valueMatch || productMatch;
    });

    // toggleProductSelection
    const toggleServiceSelection = (service) => {
        const isSelected = selectedList.some((s) => s.id === service.id);
        if (isSelected) {
            setSelectedList(selectedList.filter((s) => s.id !== service.id));
        } else {
            setSelectedList([...selectedList, service]);
        }
    };
    const toggleProductSelection = (product) => {
        setProductList((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (p) => p.id === product.id
            );

            if (isAlreadySelected) {
                return prevSelected.filter((p) => p.id !== product.id);
            } else {
                return [...prevSelected, product];
            }
        });
    };

    const handleServiceSelect = (selected) => {
        // Check if selected is properly passed and log the details
        // Update selected services
        setSelectedServiceValues(selected);

        // Check and log each service for category-related issues
        const updatedServiceList = selected.map((service) => {
            return {
                ...service,
                quantity: service.quantity || 1,
                gst: service.gst || "No GST",
                staff: service.staff || [],
                note: service.note || "No notes added",
                category: service.category, // Ensure the category is correctly assigned
            };
        });

        // After transformation, log the updated list
        setSelectedList(updatedServiceList);
    };

    const handleProductSelect = (selectedList) => {
        setProductValue(selectedList);
        // Initialize productData with the selected products and reset quantities
        setProductData(
            selectedList.map((product) => ({
                id: product.key,
                quantity: "", // Initialize with empty quantity
                unit: product.unit,
                available: product.available || 0, // Assuming product has available stock
            }))
        );
    };

    const handleProductInputChange = (index, value) => {
        const updatedProductData = [...productData];
        updatedProductData[index].quantity = value;
        setProductData(updatedProductData);
    };

    // Handle GST change
    const handleGST = (e, index) => {
        const updatedSelectedList = [...selectedList];
        updatedSelectedList[index].gst = e.target.value;
        setSelectedList(updatedSelectedList);
        updateServicesTableData(updatedSelectedList);
    };

    // Handle input change for quantity and price
    const handleInputChange = (index, field, value) => {
        if (value === "" || value === ".") {
            if (index < selectedList.length) {
                const updatedSelectedList = [...selectedList];
                updatedSelectedList[index][field] = value;
                setSelectedList(updatedSelectedList);
            } else {
                const productIndex = index - selectedList.length;
                if (productIndex < productList.length) {
                    const updatedProductList = [...productList];
                    updatedProductList[productIndex][field] = value;
                    setProductList(updatedProductList);
                }
            }
            return;
        }

        const newValue = field === "quantity" ? value : parseFloat(value);

        if (index < selectedList.length) {
            const updatedSelectedList = [...selectedList];
            updatedSelectedList[index][field] = newValue;
            setSelectedList(updatedSelectedList);
            updateServicesTableData(updatedSelectedList);
        } else {
            const productIndex = index - selectedList.length;
            if (productIndex < productList.length) {
                const updatedProductList = [...productList];
                updatedProductList[productIndex][field] = newValue;
                setProductList(updatedProductList);
            }
        }
    };

    // Update service table data
    // Add this useState at the top of your component
    const [comboServicesDetail, setComboServicesDetail] = useState([]);

    const updateServicesTableData = (updatedValues, invoiceData) => {
        const inputFieldValues = updatedValues.map((service) => ({
            quantity: service.quantity || 1, // Default quantity to 1 if missing
            price: service.price || 0, // Default price to 0 if missing
        }));

        // Extract combo services details separately
        const comboDetails = [];

        const newTableData = updatedValues.map((service, index) => {
            // Check if it's a combo and has services
            if (
                service.isCombo &&
                service.comboData &&
                service.comboData.services
            ) {
                // Store combo services details separately
                service.comboData.services.forEach(
                    (comboService, serviceIndex) => {
                        const serviceStaff =
                            Array.isArray(service.staff) &&
                            service.staff[serviceIndex]
                                ? service.staff[serviceIndex]
                                : [];

                        comboDetails.push({
                            comboId: service.id,
                            comboName: service.name,
                            serviceId:
                                comboService.id ||
                                `combo-service-${serviceIndex}`,
                            serviceName:
                                comboService.service || "Unnamed Service",
                            staff: serviceStaff,
                            quantity: service.quantity || 1,
                            gst: service.gst || "No GST",
                            category:
                                comboService.category ||
                                service.category ||
                                "Uncategorized",
                        });
                    }
                );
            }

            // Keep the original logic unchanged for all services
            return {
                ...service,
                finalPrice:
                    service.gst === "Inclusive"
                        ? (service.price / 1.18).toFixed(2) // Adjust price for inclusive GST
                        : service.gst === "Exclusive"
                        ? service.price
                        : service.price || 0, // Ensure price defaults to 0 if missing

                gst: service.gst || "No GST", // Default to empty string if gst is not set
                inputFieldValue: inputFieldValues[index], // Store quantity in inputFieldValue
                staff: service.staff || [], // Include staff data for the service
                category: service.category, // Ensure category info is included
            };
        });

        // Update combo services details separately
        setComboServicesDetail(comboDetails);
        setServicesTableData(newTableData); // Update the services table data
    };
    const handleMembershipChange = async (selectedType) => {
        // Find the full membership object based on the selected type
        console.log("Selected Membership Type:", selectedType);
        const selectedMembership = membershipOptions.find(
            (option) => option.id === selectedType
        );
        console.log("Selected Membership:", selectedMembership);
        // Set the full membership object instead of just the type
        setSelectMembership(selectedMembership || null);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (index) => {
        setIsModalOpen(index); // Set the index of the row whose modal should be open
    };

    const closeModal = () => {
        setIsModalOpen(null); // Close modal
    };
    // Handle served by (staff) selection
    const handleServedSelect = (selected, index) => {
        const isService = index < selectedList.length;

        if (isService) {
            const updatedSelectedList = [...selectedList];
            if (!updatedSelectedList[index].hasOwnProperty("staff")) {
                updatedSelectedList[index].staff = [];
            }
            updatedSelectedList[index].staff = selected;
            setSelectedList(updatedSelectedList);
            updateServicesTableData(updatedSelectedList);
        } else {
            const productIndex = index - selectedList.length;
            const updatedProductList = [...productList];
            if (!updatedProductList[productIndex].hasOwnProperty("staff")) {
                updatedProductList[productIndex].staff = [];
            }
            updatedProductList[productIndex].staff = selected;
            setProductList(updatedProductList); // Add this if you’re managing state for productList
        }

        setIsModalOpen(false);
    };

    const handleService_Select = () => {
        // Logic to handle service select
        setServiceModalOpen(false);
    };

    const handleGSTChange = (event) => {
        setIsGST(true);
    };

    const [deductedPoints, setDeductedPoints] = useState("");
    const [valueDeductedPoints, setValueDeductedPoints] = useState("");

    const fetchSpecificSerial = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token is missing.");
                return null;
            }

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get_specific_slno/`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.slno) {
                setInvoiceId(response.data.slno); // ✅ fine for UI
                return response.data.slno; // ✅ this is what you use
            } else {
                console.error("Invalid response format:", response.data);
                return null;
            }
        } catch (error) {
            console.error("Error fetching invoice ID:", error);
            return null;
        }
    };

    // Modified handleGenerateInvoice function

    const handleGenerateInvoice = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const errors = [];

            // 1. Validate Customer Name
            if (!customer_name || customer_name.trim() === "") {
                errors.push("Customer name is required");
            }

            // 2. Validate Mobile Number (exactly 10 digits)
            const mobileNoPattern = /^[0-9]{10}$/;
            if (!mobileNoPattern.test(mobile_no)) {
                errors.push("Please enter a valid 10-digit mobile number");
            }

            // 3. Validate Email (if provided)
            if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                errors.push("Please enter a valid email address");
            }

            // 4. Validate at least one service or product is selected
            if (selectedList.length === 0 && productList.length === 0) {
                errors.push("Please select at least one service or product");
            }

            // 5. Validate services
            selectedList.forEach((service) => {
                if (!service.staff || service.staff.length === 0) {
                    errors.push(
                        `Please select staff for service: ${service.name}`
                    );
                }
                if (!service.quantity || service.quantity <= 0) {
                    errors.push(
                        `Please enter valid quantity for service: ${service.name}`
                    );
                }
                if (service.price === undefined || service.price <= 0) {
                    errors.push(
                        `Please enter valid price for service: ${service.name}`
                    );
                }
            });

            // 6. Validate products
            productList.forEach((product) => {
                if (!product.quantity || product.quantity <= 0) {
                    errors.push(
                        `Please enter quantity for product: ${product.name}`
                    );
                }
                if (product.stock && product.quantity > product.stock) {
                    errors.push(
                        `Only ${product.stock} available for product: ${product.name}`
                    );
                }
                if (product.price === undefined || product.price <= 0) {
                    errors.push(
                        `Please enter valid price for product: ${product.name}`
                    );
                }
            });

            // 7. Validate GST number if GST is selected
            if (isGST && (!gst_number || gst_number.trim() === "")) {
                errors.push("GST number is required when GST is selected");
            }

            // 🔔 Show all errors via Toastify
            if (errors.length > 0) {
                errors.forEach((err) => toast.error(err));
                return;
            }

            // 📄 Proceed with invoice generation
            const generatedInvoiceId = isEditMode
                ? invoiceData.slno
                : await fetchSpecificSerial();

            setInvoiceId(generatedInvoiceId);

            let submitResult = null;
            const shouldUpdateCustomer =
                userExists &&
                (selectMembership ||
                    selectedCoupons.length > 0 ||
                    dateOfBirth ||
                    anniversaryDate);

            if (shouldUpdateCustomer) {
                submitResult = await handleUpdateCustomer(e, customerId);
            } else if (!userExists) {
                submitResult = await handleSubmit(e);
            }

            // 🧾 Navigate to invoice preview
            await navigate(
                `/${sname}/${branchName}/${generatedInvoiceId}/invoice`,
                {
                    state: {
                        customer_name,
                        email,
                        mobile_no,
                        address,
                        GBselectedServices: servicesTableData,
                        service_by,
                        discount,
                        isGST,
                        gst_number,
                        comments,
                        InvoiceId: generatedInvoiceId,
                        productData: productList,
                        deductedPoints,
                        selectMembership,
                        paymentModes,
                        selectedCoupons,
                        valueDeductedPoints,
                        isEditMode,
                        uuid: invoiceData?.id || 0,
                        comboServicesDetail,
                    },
                }
            );

            toast.success("Invoice generated successfully!");
        } catch (error) {
            console.error("Error during invoice generation:", error);
            toast.error("Something went wrong while generating the invoice.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch_id");
        console.log("ccheck membership", selectMembership);

        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${branchId}`,
                {
                    name: customer_name,
                    mobile_no,
                    email,
                    memberships: selectMembership
                        ? [
                              {
                                  program_type: selectMembership.program_type,
                              },
                          ]
                        : [],
                    d_o_b: dateOfBirth || "none",
                    d_o_a: anniversaryDate || "none",

                    coupon:
                        selectedCoupons.map((coupon) => ({
                            coupon_name: coupon.id,
                        })) || [],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            const { status, data } = response;

            if (status >= 200 && status < 300 && data.success) {
                setPopupMessage("Customer added successfully!");
                setShowPopup(true);
                return true; // Indicate success
            } else {
                throw new Error(data.message || "Failed to add customer.");
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "An error occurred.";
            setPopupMessage(errorMessage);
            setShowPopup(true);
            console.error("Error:", error.response?.data || error.message);
            return false; // Indicate failure
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchCouponData = async () => {
            const apiEndpoint = `${config.apiUrl}/api/swalook/coupon/?branch_name=${bid}`;
            try {
                const response = await axios.get(apiEndpoint, {
                    headers: {
                        Authorization: `Token ${localStorage.getItem("token")}`,
                    },
                });

                if (response.data.status) {
                    // Filter only active coupons
                    const activeCoupons = response.data.data.filter(
                        (coupon) => coupon.active
                    );
                    setCouponOptions(activeCoupons);
                }
            } catch (error) {
                console.error("Error fetching coupon data:", error);
            }
        };

        fetchCouponData();
    }, [bid]); // Runs when `bid` changes

    const handleCouponChange = (couponId) => {
        if (couponId === "None") return; // Prevent adding 'None'

        const selectedCoupon = couponOptions.find(
            (coupon) => coupon.id === couponId
        );

        if (
            selectedCoupon &&
            !selectedCoupons.some((coupon) => coupon.id === selectedCoupon.id)
        ) {
            setSelectedCoupons([...selectedCoupons, selectedCoupon]);
            // Initialize empty staff array for this coupon
            setCouponStaff((prev) => [...prev, []]);
        }

        setSelectCoupon(selectedCoupon);
    };

    const handleCouponGSTChange = (index, gstValue) => {
        setSelectedCoupons((prevCoupons) =>
            prevCoupons.map((coupon, i) =>
                i === index ? { ...coupon, gst: gstValue } : coupon
            )
        );
    };

    const handleShowInvoice = (id) => {
        navigate(`/${sname}/${branchName}/viewinvoice/${id}`);
    };

    const handleViewAllInvoices = (id) => {
        navigate(`/${sname}/${branchName}/view-all-invoices`);
    };

    const handleDeleteInvoice = async (id) => {
        const token = localStorage.getItem("token");

        try {
            const response = await axios.get(
                `${config.apiUrl}/api/swalook/delete/invoice/${id}/`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status >= 200 && response.status < 300) {
                window.location.reload(); // Reload only on success
            } else {
                throw new Error("Failed to delete invoice.");
            }
        } catch (error) {
            console.error(
                "Error deleting invoice:",
                error.response?.data || error.message
            );
        }
    };

    const handleDeleteClick = (id) => {
        setDeleteInvoiceId(id);
        setShowDeletePopup(true);
    };
    const handleMembershipStaffSelect = (selected) => {
        setMembershipStaff(selected);
    };

    // Handle coupon staff selection
    const handleCouponStaffSelect = (selected, index) => {
        const updatedCouponStaff = [...couponStaff];
        updatedCouponStaff[index] = selected;
        setCouponStaff(updatedCouponStaff);
    };
    // Open membership staff modal
    const openMembershipStaffModal = async () => {
        await fetchStaffData();
        setIsMembershipStaffModalOpen(true);
    };

    // Open coupon staff modal
    const openCouponStaffModal = async (index) => {
        await fetchStaffData();
        setSelectedCouponIndex(index);
        setIsCouponStaffModalOpen(true);
    };

    // Close modals
    const closeMembershipStaffModal = () => {
        setIsMembershipStaffModalOpen(false);
    };

    const closeCouponStaffModal = () => {
        setIsCouponStaffModalOpen(false);
        setSelectedCouponIndex(null);
    };
    const handleDeleteConfirm = async () => {
        const token = localStorage.getItem("token");
        try {
            const res = await axios.delete(
                `${config.apiUrl}/api/swalook/delete/invoice/?id=${deleteInvoiceId}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            ////console.log(res.data);
            window.location.reload();
        } catch (err) {
            ////console.log(err);
        } finally {
            setShowDeletePopup(false);
        }
    };

    const [membershipType, setMembershipType] = useState("");
    const [userPoints, setUserPoints] = useState("");
    const [couponType, setCouponType] = useState("");

    const handlePhoneBlur = async () => {
        if (
            !mobile_no ||
            mobile_no.length !== 10 ||
            !/^[0-9]{10}$/.test(mobile_no)
        ) {
            // Invalid mobile number
            resetCustomerFields();
            return;
        }

        try {
            const branchName = localStorage.getItem("branch_id");
            const token = localStorage.getItem("token");

            if (!branchName || !token) {
                console.error("Branch ID or token is missing.");
                resetCustomerFields();
                return;
            }
            //console.log("Fetching customer data for mobile:", mobile_no);
            const apiEndpoint = `${config.apiUrl}/api/swalook/get-customer-bill-app-data/2/?branch_name=${branchName}&mobile_no=${mobile_no}`;

            const response = await axios.get(apiEndpoint, {
                headers: {
                    Authorization: `Token ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const responseData = response.data;
            setCustomerId(response.data);
            setPopupData(response.data);

            if (
                responseData.status &&
                Array.isArray(responseData.data) &&
                responseData.data.length > 0
            ) {
                const userData = responseData.data[0];

                setCustomer_Name(
                    userData.name || appointment?.customerName || ""
                );
                setEmail(userData.email || appointment?.email || "");
                setCustomerData(userData);
                setUserId(userData.id || ""); // It's UUID now, not numeric
                setUserExists(true);
                setDateOfBirth(userData.d_o_b || appointment?.d_o_b || "");
                setAnniversaryDate(userData.d_o_a || appointment?.d_o_a || "");

                // Membership type handled properly now
                setMembershipType(userData.memberships?.program_type || "None");

                // Loyality points handled safely
                setUserPoints(userData.memberships?.points_hold ?? 0);

                // Handle Coupons (if any)
                if (
                    Array.isArray(userData.coupon) &&
                    userData.coupon.length > 0
                ) {
                    const userCoupons = userData.coupon.map((coupon) => ({
                        id: coupon.id,
                        coupon_name: coupon.coupon_name,
                        coupon_points_hold: coupon.coupon_points_hold,
                        couponPrice: coupon.coupon_name?.coupon_price || 0,
                        issueDate: coupon.issue_date,
                        expiryDate: coupon.expiry_date,
                        isActive: coupon.is_active,
                    }));
                    setCouponType(userCoupons);
                } else {
                    setCouponType([]);
                }

                return;
            }

            // If no user found
            resetCustomerFields();
        } catch (error) {
            console.error("Error fetching customer data:", error);
            resetCustomerFields();
        }
    };

    // Helper to reset customer fields
    const resetCustomerFields = () => {
        setUserExists(false);
        setCustomer_Name("");
        setEmail("");
        setCustomerData(null);
        setAnniversaryDate("");
        setDateOfBirth("");
    };

    const hasMembership = !!membershipType && membershipType !== "None";
    const hasCoupon = Array.isArray(couponType) && couponType.length > 0;

    const [customerId, setCustomerId] = useState("");

    // const fetchCustomerData = async () => {
    //     if (!mobile_no || mobile_no.length !== 10) {
    //         console.error("Invalid mobile number.");
    //         return;
    //     }

    //     try {
    //         const token = localStorage.getItem("token");
    //         if (!token) {
    //             console.error("Token is missing.");
    //             return;
    //         }

    //         const response = await axios.get(
    //             `${config.apiUrl}/api/swalook/get-customer-bill-app-data/?mobile_no=${mobile_no}&branch_name=${bid}`,
    //             {
    //                 headers: {
    //                     Authorization: `Token ${token}`,
    //                     "Content-Type": "application/json",
    //                 },
    //             }
    //         );

    //         setCustomerId(response.data);

    //         //console.log("Fetched data:", response.data);
    //     } catch (error) {
    //         console.error("Error fetching customer data:", error);
    //     }
    // };

    const combinedList = [...selectedList, ...productList];

    // // Debounced effect
    // useEffect(() => {
    //     if (mobile_no.length === 10) {
    //         const timeoutId = setTimeout(() => {
    //             fetchCustomerData();
    //         }, 500);

    //         return () => clearTimeout(timeoutId);
    //     }
    // }, [mobile_no]);

    const handleUpdateCustomer = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${bid}&id=${userId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                    body: JSON.stringify({
                        name: customer_name,
                        mobile_no,
                        email,
                        memberships: selectMembership || [],
                        d_o_b: dateOfBirth || "none",
                        d_o_a: anniversaryDate || "none",
                        coupon: selectedCoupons || [],
                    }),
                }
            );

            if (response.ok) {
                setPopupMessage("Customer updated successfully!");
                setShowPopup(true);
            } else {
                setPopupMessage("Failed to update customer.");
                setShowPopup(true);
            }
        } catch (error) {
            setPopupMessage("An error occurred.");
            setShowPopup(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleBeforeUnload = () => {
            // localStorage.clear(); // Clear all localStorage data
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const fetchMembershipOptions = async () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch_id"); // Assuming 'branch_id' is stored in localStorage

        if (!token || !branchId) {
            console.error("Missing token or branch ID");
            return;
        }

        try {
            const membershipResponse = await axios.get(
                `${config.apiUrl}/api/swalook/loyality_program/view/?branch_name=${branchId}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            // Check if the response contains data and status is true
            if (
                membershipResponse.data.status &&
                Array.isArray(membershipResponse.data.data)
            ) {
                const activeMemberships = membershipResponse.data.data.filter(
                    (membership) =>
                        membership.active === true &&
                        membership.program_type != "None"
                );
                console.log("memkjhjuytresdfxcvbjk", activeMemberships);
                setMembershipOptions(activeMemberships);
            } else {
                console.error(
                    "Unexpected response format or no data:",
                    membershipResponse.data
                );
                setMembershipOptions([]); // Clear options if the format is not as expected
            }
        } catch (error) {
            console.error("Error fetching membership options:", error);
            setMembershipOptions([]); // Ensure options are cleared if an error occurs
        }
    };

    useEffect(() => {
        if (mobile_no.length === 10) {
            fetchMembershipOptions();
        } else {
            setMembershipOptions([]); // Clear options if mobile number is invalid
        }
    }, [mobile_no]);

    const [selectedPayments, setSelectedPayments] = useState([]);
    const [amounts, setAmounts] = useState({});
    const options = [
        { value: "cash", label: "Cash" },
        { value: "upi", label: "UPI" },
        { value: "card", label: "Card" },
        { value: "net_banking", label: "Net Banking" },
        { value: "other", label: "Other" },
    ];

    const membershipPrice = selectMembership?.price || 0;

    const couponDiscount = selectCoupon?.coupon_price || 0;
    const grandTotal =
        selectedList.reduce(
            (sum, service) =>
                sum + (service.price || 0) * (service.quantity || 1),
            0
        ) +
        productList.reduce(
            (sum, product) =>
                sum + (product.price || 0) * (product.quantity || 1),
            0
        ) +
        membershipPrice +
        couponDiscount -
        deductedPoints -
        valueDeductedPoints;

    const formattedGrandTotal = isNaN(grandTotal) ? 0 : grandTotal;

    const grandTotalFormatted = formattedGrandTotal.toFixed(2);
    const handleInvoiceSubmit = (e) => {
        if (grandTotal) {
        } else {
            e.preventDefault();
            alert("Required field not selected ");
        }
    };
    useEffect(() => {
        if (mobile_no.length === 10) {
            handlePhoneBlur();
        }
    }, [mobile_no]);

    const handleMembershipGST = (gstValue) => {
        setSelectMembership((prev) => ({
            ...prev,
            gst: gstValue, // Update GST in the membership object
        }));
    };
    const [comboServiceModal, setComboServiceModal] = useState({
        comboIndex: null,
        serviceIndex: null,
    });

    const openComboServiceModal = async (comboIndex, serviceIndex) => {
        await fetchStaffData();
        setComboServiceModal({ comboIndex, serviceIndex });
    };

    const closeComboServiceModal = () => {
        setComboServiceModal({ comboIndex: null, serviceIndex: null });
    };

    const handleComboServiceStaffSelect = (
        selected,
        comboIndex,
        serviceIndex
    ) => {
        const updatedSelectedList = [...selectedList];

        const comboItem = updatedSelectedList[comboIndex];
        if (!comboItem) return;

        // Ensure comboData and services array exist
        if (
            !comboItem.comboData ||
            !Array.isArray(comboItem.comboData.services)
        ) {
            console.error("Combo data structure invalid at index:", comboIndex);
            return;
        }

        // ✅ Update inside comboData.services (this is what UI reads)
        comboItem.comboData.services[serviceIndex].staff = selected;

        // ✅ Also keep legacy 'staff' array structure for your previous logic
        if (!Array.isArray(comboItem.staff)) {
            comboItem.staff = [];
        }
        comboItem.staff[serviceIndex] = selected;

        updatedSelectedList[comboIndex] = comboItem;

        setSelectedList(updatedSelectedList);
        updateServicesTableData(updatedSelectedList);
        closeComboServiceModal();
    };

    // Use useLocation to access the passed state

    // Set initial values from the data
    useEffect(() => {
        if (appointment) {
            setCustomer_Name(appointment.customerName || "");
            setMobileNo(appointment.phoneNumber || "");
            setEmail(appointment.email || "");
            setAnniversaryDate(appointment.d_o_a || "");
            setDateOfBirth(appointment.d_o_b || "");
            setService(appointment.services || []);
            setSelectedList(
                (appointment.services || []).map((service) => ({
                    ...service,
                    // Always make staff an array for easy Select and rendering
                    staff: Array.isArray(service.staff)
                        ? service.staff
                        : service.staff
                        ? [service.staff]
                        : [],
                }))
            );
        } else if (invoiceData && isEditMode) {
            // Handle data coming from ViewAllInvoices (edit invoice)
            setCustomer_Name(invoiceData.customerName || "");
            setMobileNo(invoiceData.phoneNumber || "");
            setEmail(invoiceData.email || "");
            setAddress(invoiceData.address || "");
            setComments(invoiceData.comment || "");
            setIsGST(invoiceData.isGST || false);
            setGSTNumber(invoiceData.gst_number || "");
            setDiscount(invoiceData.discount || 0);

            // Transform services
            const transformedServices = invoiceData.services.map((service) => ({
                id: service.id || service.service_id, // Ensure ID is consistent
                name: service.Description || service.name,
                price: service.Price || 0,
                quantity: service.Quantity || 1,
                discount: service.Discount || 0,
                staff: service.Staff ? [{ label: service.Staff }] : [],
                category: service.category || "Uncategorized",
                gst: service.gst || "No GST",
                inputFieldValue: {
                    quantity: service.Quantity || 1,
                    price: service.Price || 0,
                },
                // Add any other required properties
            }));
            console.log("invoiceData.combo_details", invoiceData.combo_details);
            const comboDetails = (invoiceData.combo_details || []).map(
                (combo, comboIndex) => ({
                    id: `combo-${comboIndex}`,
                    name: combo.combo_name || `Combo ${comboIndex + 1}`,
                    price: parseFloat(combo.total_price || 0),
                    quantity: 1,
                    gst: "No GST",
                    category: combo.category || "Uncategorized",
                    isCombo: true,
                    comboData: {
                        comboName:
                            combo.combo_name || `Combo ${comboIndex + 1}`,
                        services: combo.services.map((srv, idx) => {
                            // 🧠 normalize staff for Select component
                            const normalizedStaff = Array.isArray(srv.staff)
                                ? srv.staff.map((st) =>
                                      typeof st === "string"
                                          ? { label: st, value: st }
                                          : {
                                                label:
                                                    st.label ||
                                                    st.name ||
                                                    st.value ||
                                                    "",
                                                value:
                                                    st.value ||
                                                    st.label ||
                                                    st.name ||
                                                    "",
                                            }
                                  )
                                : [];

                            return {
                                service_Id:
                                    srv.service_Id ||
                                    `combo-service-${comboIndex}-${idx}`,
                                service: srv.service_name || "Unnamed Service",
                                quantity: srv.quantity || 1,
                                gst: srv.gst || "No GST",
                                staff: normalizedStaff,
                                category:
                                    srv.category ||
                                    combo.category ||
                                    "Uncategorized",
                            };
                        }),
                    },
                })
            );

            console.log("✅ Transformed Combo Details:", comboDetails);

            const combinedServices = [...transformedServices, ...comboDetails];
            console.log("Combined Services:", combinedServices);
            setComboServicesDetail(comboDetails);
            setService(combinedServices);
            setServicesTableData(transformedServices);

            setSelectedList(combinedServices);

            // Transform products
            setProductList(invoiceData.products || []);

            // Set payment modes
            if (
                invoiceData.paymentModes &&
                invoiceData.paymentModes.length > 0
            ) {
                const modes = {};
                invoiceData.paymentModes.forEach((mode) => {
                    modes[mode.mode] = mode.amount;
                });
                setPaymentModes(modes);
            }
        }
    }, [appointment, invoiceData, isEditMode]);

    // Payment mode handlers
    const handleSelectChange = (selectedOptions) => {
        const updatedPayments = {};
        selectedOptions.forEach((option) => {
            updatedPayments[option.value] = paymentModes[option.value] || "";
        });
        setPaymentModes(updatedPayments);
    };

    const handleAmountChange = (mode, value) => {
        setPaymentModes((prev) => ({
            ...prev,
            [mode]: value,
        }));
    };
    // State for payment modes and discount
    const [paymentModes, setPaymentModes] = useState(
        invoiceData?.paymentModes?.reduce((acc, mode) => {
            acc[mode.mode] = mode.amount;
            return acc;
        }, {}) || {}
    );
    const [discount, setDiscount] = useState(invoiceData?.discount || 0);

    const totalPayment = Object.values(paymentModes).reduce(
        (sum, amount) => sum + (parseFloat(amount) || 0),
        0
    );

    return (
        <>
            <div className="bg-gray-50 min-h-screen">
                <Header />
                <VertNav />

                <div className="md:ml-72 p-6">
                    {/* Customer Summary Section */}
                    {userExists && (
                        <div className="mb-8">
                            <CustomerSummary
                                dataPromise={Promise.resolve(customerId)}
                                mobile_no={mobile_no}
                                bid={bid}
                            />
                        </div>
                    )}

                    {/* Invoice Form Section */}
                    <div className="bg-white rounded-2xl shadow-md p-8 mb-8">
                        <div className="flex justify-between items-center mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                                <svg
                                    className="w-6 h-6 mr-2 text-blue-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                                New Invoice
                            </h2>
                            <button
                                onClick={handleViewAllInvoices}
                                className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
                            >
                                View All Invoices
                                <svg
                                    className="w-4 h-4 ml-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </button>
                        </div>

                        <form
                            onSubmit={handleGenerateInvoice}
                            className="space-y-8"
                        >
                            {/* Customer Details Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                    <svg
                                        className="w-5 h-5 mr-2 text-blue-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        />
                                    </svg>
                                    Customer Details
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div className="flex flex-col">
                                        <label className="text-sm font-medium text-gray-700 mb-1">
                                            Phone Number
                                        </label>
                                        <input
                                            type="tel"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                            placeholder="Enter 10-digit number"
                                            value={mobile_no}
                                            required
                                            onChange={(e) => {
                                                const value =
                                                    e.target.value.replace(
                                                        /\D/g,
                                                        ""
                                                    );
                                                if (value.length <= 10) {
                                                    setMobileNo(value);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="flex flex-col relative">
                                        <label className="text-sm font-medium text-gray-700 mb-1">
                                            Full Name
                                        </label>
                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                            placeholder="Customer full name"
                                            value={customer_name}
                                            required
                                            onChange={handleNameChange}
                                            onFocus={() =>
                                                customer_name.length > 0 &&
                                                setShowDropdown(true)
                                            }
                                            onBlur={() =>
                                                setTimeout(
                                                    () =>
                                                        setShowDropdown(false),
                                                    200
                                                )
                                            }
                                        />

                                        {showDropdown &&
                                            filteredCustomers.length > 0 && (
                                                <div className="absolute z-10 top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                                    {filteredCustomers.map(
                                                        (customer) => (
                                                            <div
                                                                key={
                                                                    customer.id
                                                                }
                                                                className="p-3 hover:bg-blue-50 cursor-pointer flex justify-between items-center border-b border-gray-100 last:border-b-0"
                                                                onClick={() =>
                                                                    handleCustomerSelect(
                                                                        customer
                                                                    )
                                                                }
                                                            >
                                                                <span className="text-gray-800">
                                                                    {
                                                                        customer.name
                                                                    }
                                                                </span>
                                                                <span className="text-gray-500 text-sm">
                                                                    {customer.mobile_no ||
                                                                        "No phone"}
                                                                </span>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                    </div>

                                    <div className="flex flex-col">
                                        <label className="text-sm font-medium text-gray-700 mb-1">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                            placeholder="Customer email"
                                            value={email}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                                    <div className="flex flex-col">
                                        <label className="text-sm font-medium text-gray-700 mb-1">
                                            Date of Birth
                                        </label>
                                        <input
                                            type="date"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                            max={
                                                new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                            }
                                            value={dateOfBirth || ""}
                                            onChange={(e) =>
                                                setDateOfBirth(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="flex flex-col">
                                        <label className="text-sm font-medium text-gray-700 mb-1">
                                            Date of Anniversary
                                        </label>
                                        <input
                                            type="date"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                            max={
                                                new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                            }
                                            value={anniversaryDate || ""}
                                            onChange={(e) =>
                                                setAnniversaryDate(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Services and Products Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                    <svg
                                        className="w-5 h-5 mr-2 text-blue-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M17 14v6m-3-3h6M6 10h2a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2zm10-4a2 2 0 11-4 0 2 2 0 014 0zM6 20a2 2 0 100-4 2 2 0 000 4z"
                                        />
                                    </svg>
                                    Services & Products
                                </h3>

                                <div className="flex space-x-4 mb-6">
                                    <button
                                        type="button"
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center transition"
                                        onClick={() => {
                                            setServiceModalOpen(true);
                                            fetchServiceCategoryData();
                                        }}
                                    >
                                        <svg
                                            className="w-4 h-4 mr-1"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                        Add Services
                                    </button>

                                    <button
                                        type="button"
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center transition"
                                        onClick={async () => {
                                            await fetchData();
                                            setProductModalOpen(true);
                                        }}
                                    >
                                        <svg
                                            className="w-4 h-4 mr-1"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                        Add Products
                                    </button>
                                </div>
                                {/* Service Selection Modal */}
                                {isServiceModalOpen && (
                                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                                        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                                            {/* Modal Header */}
                                            <div className="flex justify-between items-center border-b p-4">
                                                <h3 className="text-xl font-bold text-gray-800">
                                                    Select Services
                                                </h3>
                                                <button
                                                    onClick={() =>
                                                        setServiceModalOpen(
                                                            false
                                                        )
                                                    }
                                                    className="text-gray-500 hover:text-gray-700 transition"
                                                >
                                                    <FaTimes size={24} />
                                                </button>
                                            </div>

                                            {/* Modal Body */}
                                            <div className="p-4 overflow-y-auto flex-grow">
                                                {/* Search and Filters */}
                                                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                                                    <div className="relative flex-grow">
                                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                            <svg
                                                                className="h-5 w-5 text-gray-400"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={
                                                                        2
                                                                    }
                                                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                                />
                                                            </svg>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            placeholder="Search services or categories..."
                                                            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                            value={searchQuery}
                                                            onChange={(e) =>
                                                                setSearchQuery(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </div>

                                                    <div className="flex items-center space-x-4">
                                                        {["Male", "Female"].map(
                                                            (gender) => (
                                                                <label
                                                                    key={gender}
                                                                    className="flex items-center space-x-2"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={genderFilter.includes(
                                                                            gender
                                                                        )}
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleGenderFilterToggle(
                                                                                gender,
                                                                                e
                                                                                    .target
                                                                                    .checked
                                                                            )
                                                                        }
                                                                        className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                    />
                                                                    <span className="text-sm text-gray-700">
                                                                        {gender}
                                                                    </span>
                                                                </label>
                                                            )
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Service Categories Grid */}
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    {filteredCategories.map(
                                                        (category) => (
                                                            <div
                                                                key={
                                                                    category.key
                                                                }
                                                                className="border border-gray-200 rounded-lg overflow-hidden"
                                                            >
                                                                <div className="bg-gray-100 px-4 py-3 border-b">
                                                                    <h4 className="font-semibold text-gray-800">
                                                                        {
                                                                            category.value
                                                                        }
                                                                    </h4>
                                                                </div>
                                                                <ul className="divide-y divide-gray-200">
                                                                    {category.services
                                                                        .filter(
                                                                            (
                                                                                service
                                                                            ) => {
                                                                                // Show all if no filter is applied
                                                                                if (
                                                                                    genderFilter.length ===
                                                                                    0
                                                                                )
                                                                                    return true;

                                                                                // Show services based on gender selection
                                                                                if (
                                                                                    genderFilter.includes(
                                                                                        "Male"
                                                                                    ) &&
                                                                                    genderFilter.includes(
                                                                                        "Female"
                                                                                    )
                                                                                ) {
                                                                                    return true; // Show all if both are selected
                                                                                } else if (
                                                                                    genderFilter.includes(
                                                                                        "Male"
                                                                                    )
                                                                                ) {
                                                                                    return service.for_men;
                                                                                } else if (
                                                                                    genderFilter.includes(
                                                                                        "Female"
                                                                                    )
                                                                                ) {
                                                                                    return service.for_women;
                                                                                }

                                                                                return false;
                                                                            }
                                                                        )
                                                                        .map(
                                                                            (
                                                                                service
                                                                            ) => (
                                                                                <li
                                                                                    key={
                                                                                        service.id
                                                                                    }
                                                                                    className="px-4 py-3 hover:bg-gray-50"
                                                                                >
                                                                                    <div className="flex items-center justify-between">
                                                                                        <label className="flex items-center space-x-3 cursor-pointer">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={selectedList.some(
                                                                                                    (
                                                                                                        s
                                                                                                    ) =>
                                                                                                        s.id ===
                                                                                                            service.id ||
                                                                                                        s.name ===
                                                                                                            service.name
                                                                                                )}
                                                                                                onChange={() =>
                                                                                                    toggleServiceSelection(
                                                                                                        service
                                                                                                    )
                                                                                                }
                                                                                                className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                                            />
                                                                                            <div className="flex flex-col">
                                                                                                <span className="text-sm font-medium text-gray-700">
                                                                                                    {
                                                                                                        service.name
                                                                                                    }
                                                                                                    {service.isCombo && (
                                                                                                        <span className="text-xs text-gray-500 ml-1">
                                                                                                            (Combo)
                                                                                                        </span>
                                                                                                    )}
                                                                                                </span>
                                                                                                {service.isCombo &&
                                                                                                    service.serviceNames && (
                                                                                                        <span className="text-xs text-gray-500 mt-1">
                                                                                                            (
                                                                                                            {
                                                                                                                service.serviceNames
                                                                                                            }

                                                                                                            )
                                                                                                        </span>
                                                                                                    )}
                                                                                            </div>
                                                                                        </label>
                                                                                        <span className="text-sm font-semibold text-gray-700">
                                                                                            ₹
                                                                                            {
                                                                                                service.price
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        )}
                                                                </ul>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </div>

                                            {/* Modal Footer */}
                                            <div className="border-t p-4 bg-gray-50">
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <p className="text-sm text-gray-600">
                                                            Selected:{" "}
                                                            <span className="font-medium">
                                                                {
                                                                    selectedList.length
                                                                }{" "}
                                                                services
                                                            </span>
                                                        </p>
                                                        {selectedList.length >
                                                            0 && (
                                                            <p className="text-xs text-gray-500 mt-1">
                                                                {selectedList
                                                                    .map(
                                                                        (s) =>
                                                                            s.name
                                                                    )
                                                                    .join(", ")}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <button
                                                        onClick={() => {
                                                            finalizeSelection(
                                                                selectedList
                                                            );
                                                            setServiceModalOpen(
                                                                false
                                                            );
                                                        }}
                                                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition"
                                                    >
                                                        Add Services
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Product Selection Modal */}
                                {isProductModalOpen && (
                                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                                        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                                            {/* Modal Header */}
                                            <div className="flex justify-between items-center border-b p-4">
                                                <h3 className="text-xl font-bold text-gray-800">
                                                    Select Products
                                                </h3>
                                                <button
                                                    onClick={() =>
                                                        setProductModalOpen(
                                                            false
                                                        )
                                                    }
                                                    className="text-gray-500 hover:text-gray-700 transition"
                                                >
                                                    <FaTimes size={24} />
                                                </button>
                                            </div>

                                            {/* Modal Body */}
                                            <div className="p-4 overflow-y-auto flex-grow">
                                                {/* Search */}
                                                <div className="flex justify-between items-center mb-6">
                                                    <div className="relative flex-grow">
                                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                            <svg
                                                                className="h-5 w-5 text-gray-400"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={
                                                                        2
                                                                    }
                                                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                                />
                                                            </svg>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            placeholder="Search products or categories..."
                                                            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                            value={searchQuery2}
                                                            onChange={(e) =>
                                                                setSearchQuery2(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                {filteredproduct.length ===
                                                0 ? (
                                                    <div className="flex justify-center items-center h-32">
                                                        <p className="text-gray-500">
                                                            No products
                                                            available
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        {filteredproduct.map(
                                                            (category) => (
                                                                <div
                                                                    key={
                                                                        category.key
                                                                    }
                                                                    className="border border-gray-200 rounded-lg overflow-hidden"
                                                                >
                                                                    <div className="bg-gray-100 px-4 py-3 border-b">
                                                                        <h4 className="font-semibold text-gray-800">
                                                                            {
                                                                                category.value
                                                                            }
                                                                        </h4>
                                                                    </div>
                                                                    <ul className="divide-y divide-gray-200">
                                                                        {category.products.map(
                                                                            (
                                                                                product
                                                                            ) => (
                                                                                <li
                                                                                    key={
                                                                                        product.id
                                                                                    }
                                                                                    className="px-4 py-3 hover:bg-gray-50"
                                                                                >
                                                                                    <div className="flex items-center justify-between">
                                                                                        <label className="flex items-center space-x-3 cursor-pointer">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={productList.some(
                                                                                                    (
                                                                                                        p
                                                                                                    ) =>
                                                                                                        p.id ===
                                                                                                        product.id
                                                                                                )}
                                                                                                onChange={() =>
                                                                                                    toggleProductSelection(
                                                                                                        product
                                                                                                    )
                                                                                                }
                                                                                                className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                                            />
                                                                                            <span className="text-sm font-medium text-gray-700">
                                                                                                {
                                                                                                    product.name
                                                                                                }
                                                                                            </span>
                                                                                        </label>
                                                                                        <span className="text-sm font-semibold text-gray-700">
                                                                                            ₹
                                                                                            {
                                                                                                product.price
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Modal Footer */}
                                            <div className="border-t p-4 bg-gray-50">
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <p className="text-sm text-gray-600">
                                                            Selected:{" "}
                                                            <span className="font-medium">
                                                                {
                                                                    productList.length
                                                                }{" "}
                                                                products
                                                            </span>
                                                        </p>
                                                        {productList.length >
                                                            0 && (
                                                            <p className="text-xs text-gray-500 mt-1">
                                                                {productList
                                                                    .map(
                                                                        (p) =>
                                                                            p.name
                                                                    )
                                                                    .join(", ")}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <button
                                                        onClick={() => {
                                                            finalizeSelection(
                                                                selectedList
                                                            );
                                                            setProductModalOpen(
                                                                false
                                                            );
                                                        }}
                                                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition"
                                                    >
                                                        Add Products
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* Services Table */}
                                {combinedList.length > 0 && (
                                    <div className="mb-6">
                                        <h4 className="text-md font-medium text-gray-700 mb-3">
                                            Selected Services & Products
                                        </h4>
                                        <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Category
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Name
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Price
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Quantity
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            GST
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Staff
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {combinedList.map(
                                                        (item, index) => {
                                                            // If it's a combo, we need to render each service in the combo
                                                            if (
                                                                item.isCombo &&
                                                                item.comboData &&
                                                                item.comboData
                                                                    .services
                                                            ) {
                                                                return (
                                                                    <>
                                                                        {/* Combo header row */}
                                                                        <tr
                                                                            key={`combo-${index}`}
                                                                            className="bg-blue-50"
                                                                        >
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                                {item.category ||
                                                                                    "Uncategorized"}
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                                <div className="flex flex-col">
                                                                                    <span>
                                                                                        {
                                                                                            item.name
                                                                                        }
                                                                                    </span>
                                                                                    <span className="text-xs text-gray-500">
                                                                                        (Combo)
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                {
                                                                                    item.price
                                                                                }
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                {item.quantity ||
                                                                                    1}
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                {item.gst ||
                                                                                    "No GST"}
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                {/* Combo-level staff selection removed */}
                                                                                <span className="text-xs text-gray-500">
                                                                                    Select
                                                                                    staff
                                                                                    for
                                                                                    each
                                                                                    service
                                                                                    below
                                                                                </span>
                                                                            </td>
                                                                        </tr>

                                                                        {/* Individual services within the combo */}
                                                                        {item.comboData.services.map(
                                                                            (
                                                                                service,
                                                                                serviceIndex
                                                                            ) => {
                                                                                const serviceKey = `combo-${index}-service-${serviceIndex}`;
                                                                                const serviceStaff =
                                                                                    // ✅ Priority 1: staff defined at service level
                                                                                    Array.isArray(
                                                                                        service.staff
                                                                                    )
                                                                                        ? service.staff
                                                                                        : service.staff
                                                                                        ? [
                                                                                              service.staff,
                                                                                          ]
                                                                                        : // ✅ Priority 2: staff defined at combo level (per service index)
                                                                                        Array.isArray(
                                                                                              item.staff
                                                                                          ) &&
                                                                                          item
                                                                                              .staff[
                                                                                              serviceIndex
                                                                                          ]
                                                                                        ? item
                                                                                              .staff[
                                                                                              serviceIndex
                                                                                          ]
                                                                                        : [];

                                                                                const serviceStaffUpdate =
                                                                                    Array.isArray(
                                                                                        service.staff
                                                                                    )
                                                                                        ? service.staff
                                                                                        : service.staff
                                                                                        ? [
                                                                                              service.staff,
                                                                                          ]
                                                                                        : [];

                                                                                console.log(
                                                                                    "Service Staff for",
                                                                                    service,
                                                                                    ":",
                                                                                    serviceStaff
                                                                                );
                                                                                return (
                                                                                    <tr
                                                                                        key={
                                                                                            serviceKey
                                                                                        }
                                                                                        className="bg-gray-50"
                                                                                    >
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 pl-8">
                                                                                            {service.category ||
                                                                                                item.category ||
                                                                                                "Uncategorized"}
                                                                                        </td>
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 pl-8">
                                                                                            <div className="flex flex-col">
                                                                                                <span>
                                                                                                    {service.service ||
                                                                                                        "Unnamed Service"}
                                                                                                </span>
                                                                                                <span className="text-xs text-gray-500">
                                                                                                    (Part
                                                                                                    of{" "}
                                                                                                    {
                                                                                                        item.name
                                                                                                    }{" "}
                                                                                                    combo)
                                                                                                </span>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                            {/* Price is part of the combo, not individually editable */}
                                                                                            <span className="text-gray-400">
                                                                                                Included
                                                                                                in
                                                                                                combo
                                                                                            </span>
                                                                                        </td>
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                            {/* Quantity matches the combo quantity */}
                                                                                            {item.quantity ||
                                                                                                1}
                                                                                        </td>
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                            {/* GST inherited from combo */}
                                                                                            {item.gst ||
                                                                                                "No GST"}
                                                                                        </td>
                                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                            <div
                                                                                                className="border border-gray-300 px-3 py-1 bg-white text-black rounded-lg cursor-pointer hover:bg-gray-50 transition"
                                                                                                onClick={() =>
                                                                                                    openComboServiceModal(
                                                                                                        index,
                                                                                                        serviceIndex
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {serviceStaff &&
                                                                                                serviceStaff.length >
                                                                                                    0 ? (
                                                                                                    Array.isArray(
                                                                                                        serviceStaff
                                                                                                    ) ? (
                                                                                                        serviceStaff
                                                                                                            .map(
                                                                                                                (
                                                                                                                    s
                                                                                                                ) =>
                                                                                                                    s?.label
                                                                                                                        ? s.label
                                                                                                                        : s
                                                                                                            )
                                                                                                            .join(
                                                                                                                ", "
                                                                                                            )
                                                                                                    ) : (
                                                                                                        serviceStaff?.label ||
                                                                                                        serviceStaff
                                                                                                    )
                                                                                                ) : (
                                                                                                    <span className="text-red-500">
                                                                                                        Select
                                                                                                        Staff
                                                                                                        *
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </>
                                                                );
                                                            }

                                                            // Regular service or product row
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                        {item.category ||
                                                                            "Uncategorized"}
                                                                    </td>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                        <div className="flex flex-col">
                                                                            <span>
                                                                                {item.name ||
                                                                                    item.Description}
                                                                            </span>
                                                                            {item.isCombo &&
                                                                                item.serviceNames && (
                                                                                    <span className="text-xs text-gray-500">
                                                                                        (
                                                                                        {
                                                                                            item.serviceNames
                                                                                        }

                                                                                        )
                                                                                    </span>
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                        <input
                                                                            type="number"
                                                                            className="border border-gray-300 rounded-lg w-20 px-2 py-1 text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                            placeholder="Price"
                                                                            min="0"
                                                                            value={
                                                                                item.gst ===
                                                                                "Inclusive"
                                                                                    ? (
                                                                                          item.price /
                                                                                          1.18
                                                                                      ).toFixed(
                                                                                          2
                                                                                      )
                                                                                    : item.price ||
                                                                                      ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handleInputChange(
                                                                                    index,
                                                                                    "price",
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                        {item.stock ? (
                                                                            <div className="flex flex-col items-start justify-start">
                                                                                <input
                                                                                    type="text"
                                                                                    inputMode="decimal"
                                                                                    className="border border-gray-300 rounded-lg w-24 px-2 py-1 text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                                    placeholder="Qty"
                                                                                    value={
                                                                                        item.quantity !== undefined && item.quantity !== null
                                                                                            ? item.quantity
                                                                                            : ""
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        const raw = e.target.value;
                                                                                        if (raw === "" || raw === ".") {
                                                                                            handleInputChange(index, "quantity", raw);
                                                                                            return;
                                                                                        }
                                                                                        if (!/^\d*\.?\d*$/.test(raw)) return;
                                                                                        const num = parseFloat(raw);
                                                                                        if (!isNaN(num) && num > parseFloat(item.stock)) {
                                                                                            alert(`Only ${item.stock} available in stock`);
                                                                                            handleInputChange(index, "quantity", String(item.stock));
                                                                                            return;
                                                                                        }
                                                                                        handleInputChange(index, "quantity", raw);
                                                                                    }}
                                                                                    onBlur={(e) => {
                                                                                        const num = parseFloat(e.target.value);
                                                                                        if (isNaN(num) || num <= 0) {
                                                                                            handleInputChange(index, "quantity", "");
                                                                                        } else {
                                                                                            handleInputChange(index, "quantity", String(num));
                                                                                        }
                                                                                    }}
                                                                                    style={{
                                                                                        borderColor:
                                                                                            !item.quantity ||
                                                                                            item.quantity === "0" ||
                                                                                            (item.stock && parseFloat(item.quantity) > parseFloat(item.stock))
                                                                                                ? "red"
                                                                                                : "inherit",
                                                                                    }}
                                                                                />
                                                                                <span className="text-xs text-gray-500 mt-1">
                                                                                    Available:{" "}
                                                                                    {
                                                                                        item.stock
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <input
                                                                                type="text"
                                                                                inputMode="decimal"
                                                                                className="border border-gray-300 rounded-lg w-24 px-2 py-1 text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                                placeholder="Qty"
                                                                                value={
                                                                                    item.quantity !== undefined && item.quantity !== null
                                                                                        ? item.quantity
                                                                                        : "1"
                                                                                }
                                                                                onChange={(e) => {
                                                                                    const raw = e.target.value;
                                                                                    if (raw === "" || raw === ".") {
                                                                                        handleInputChange(index, "quantity", raw);
                                                                                        return;
                                                                                    }
                                                                                    if (!/^\d*\.?\d*$/.test(raw)) return;
                                                                                    handleInputChange(index, "quantity", raw);
                                                                                }}
                                                                                onBlur={(e) => {
                                                                                    const num = parseFloat(e.target.value);
                                                                                    if (isNaN(num) || num <= 0) {
                                                                                        handleInputChange(index, "quantity", "1");
                                                                                    } else {
                                                                                        handleInputChange(index, "quantity", String(num));
                                                                                    }
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                        <select
                                                                            className="border border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                            value={
                                                                                item.gst ||
                                                                                "No GST"
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handleGST(
                                                                                    e,
                                                                                    index
                                                                                )
                                                                            }
                                                                            required
                                                                        >
                                                                            <option value="No GST">
                                                                                No
                                                                                GST
                                                                            </option>
                                                                            <option value="Inclusive">
                                                                                Inclusive
                                                                            </option>
                                                                            <option value="Exclusive">
                                                                                Exclusive
                                                                            </option>
                                                                        </select>
                                                                    </td>
                                                                    <td
                                                                        className="px-4 py-3 whitespace-nowrap text-sm text-gray-500"
                                                                        onClick={
                                                                            fetchStaffData
                                                                        }
                                                                    >
                                                                        <div
                                                                            className="border border-gray-300 px-3 py-1 bg-white text-black rounded-lg cursor-pointer hover:bg-gray-50 transition"
                                                                            onClick={() =>
                                                                                openModal(
                                                                                    index
                                                                                )
                                                                            }
                                                                        >
                                                                            {item &&
                                                                            item.staff ? (
                                                                                Array.isArray(
                                                                                    item.staff
                                                                                ) ? (
                                                                                    item
                                                                                        .staff
                                                                                        .length >
                                                                                    0 ? (
                                                                                        item.staff
                                                                                            .map(
                                                                                                (
                                                                                                    s
                                                                                                ) =>
                                                                                                    s?.label
                                                                                                        ? s.label
                                                                                                        : s
                                                                                            )
                                                                                            .join(
                                                                                                ", "
                                                                                            )
                                                                                    ) : (
                                                                                        <span className="text-red-500">
                                                                                            Select
                                                                                            Staff
                                                                                            *
                                                                                        </span>
                                                                                    )
                                                                                ) : (
                                                                                    item
                                                                                        .staff
                                                                                        ?.label ||
                                                                                    item.staff || (
                                                                                        <span className="text-red-500">
                                                                                            Select
                                                                                            Staff
                                                                                            *
                                                                                        </span>
                                                                                    )
                                                                                )
                                                                            ) : (
                                                                                <span className="text-red-500">
                                                                                    Select
                                                                                    Staff
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        {isModalOpen ===
                                                                            index && (
                                                                            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                                                                                <div className="bg-white w-96 p-4 rounded-[2.5rem] shadow-lg">
                                                                                    <h3 className="text-lg font-bold mb-4">
                                                                                        Select
                                                                                        Staff
                                                                                    </h3>
                                                                                    <Select
                                                                                        isMulti
                                                                                        isSearchable={
                                                                                            false
                                                                                        }
                                                                                        options={
                                                                                            staffData
                                                                                        }
                                                                                        placeholder="Select Served By"
                                                                                        className="rounded-[2.5rem] font-semibold"
                                                                                        value={
                                                                                            item.staff ||
                                                                                            []
                                                                                        }
                                                                                        onChange={(
                                                                                            selected
                                                                                        ) =>
                                                                                            handleServedSelect(
                                                                                                selected,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                        styles={{
                                                                                            control:
                                                                                                (
                                                                                                    base
                                                                                                ) => ({
                                                                                                    ...base,
                                                                                                    borderRadius:
                                                                                                        "2.5rem",
                                                                                                    padding:
                                                                                                        "2px",
                                                                                                }),
                                                                                        }}
                                                                                    />

                                                                                    <div className="flex justify-end mt-4">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="px-4 py-2 bg-gray-300 text-black rounded-[2.5rem] mr-2"
                                                                                            onClick={
                                                                                                closeModal
                                                                                            }
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="px-4 py-2 bg-blue-500 text-white rounded-[2.5rem]"
                                                                                            onClick={
                                                                                                closeModal
                                                                                            }
                                                                                        >
                                                                                            Done
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                                <tfoot className="bg-blue-50">
                                                    <tr className="font-semibold text-blue-700">
                                                        <td
                                                            className="px-4 py-3 text-left"
                                                            colSpan="2"
                                                        >
                                                            Grand Total
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            {combinedList
                                                                .reduce(
                                                                    (
                                                                        sum,
                                                                        service
                                                                    ) =>
                                                                        sum +
                                                                        (service.price ||
                                                                            0) *
                                                                            (service.quantity ||
                                                                                1),
                                                                    0
                                                                )
                                                                .toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            {combinedList.reduce(
                                                                (
                                                                    sum,
                                                                    service
                                                                ) =>
                                                                    sum +
                                                                    (Number(
                                                                        service.quantity
                                                                    ) || 1),
                                                                0
                                                            )}
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            {combinedList
                                                                .reduce(
                                                                    (
                                                                        sum,
                                                                        service
                                                                    ) =>
                                                                        sum +
                                                                        (service.gst ===
                                                                        "Inclusive"
                                                                            ? service.price *
                                                                              0.18
                                                                            : 0),
                                                                    0
                                                                )
                                                                .toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-3"></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {/* Products Table */}
                                {product_value.length > 0 && (
                                    <div>
                                        <h4 className="text-md font-medium text-gray-700 mb-3">
                                            Selected Products
                                        </h4>
                                        <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Category
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Product Name
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Quantity
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Unit
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Available
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {productList.map(
                                                        (product, index) => (
                                                            <tr key={index}>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {
                                                                        product.category
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                    {
                                                                        product.name
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    <input
                                                                        type="number"
                                                                        className="border border-gray-300 rounded-lg w-20 px-2 py-1 text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                        placeholder="Enter Quantity"
                                                                        required
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleProductInputChange(
                                                                                index,
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        style={{
                                                                            borderColor:
                                                                                product.quantity ===
                                                                                    "" ||
                                                                                product.quantity ===
                                                                                    "0"
                                                                                    ? "red"
                                                                                    : "inherit",
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {
                                                                        product.unit
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {
                                                                        product.quantity
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Membership & Coupons Section */}
                            {(userExists && (hasMembership || hasCoupon)) ||
                            mobile_no.length === 10 ||
                            mobile_no.length === 12 ? (
                                <div className="bg-gray-50 p-6 rounded-xl">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                        <svg
                                            className="w-5 h-5 mr-2 text-blue-500"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                                            />
                                        </svg>
                                        Membership & Coupons
                                    </h3>

                                    {userExists &&
                                        (hasMembership || hasCoupon) && (
                                            <div className="mb-6">
                                                <h4 className="text-md font-medium text-gray-700 mb-3">
                                                    Current Benefits
                                                </h4>
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="min-w-full divide-y divide-gray-200">
                                                        <thead className="bg-gray-100">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                    Membership/Coupon
                                                                </th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                    Balance
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="bg-white divide-y divide-gray-200">
                                                            {hasMembership && (
                                                                <tr>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                        {
                                                                            membershipType
                                                                        }
                                                                    </td>
                                                                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                        {
                                                                            userPoints
                                                                        }{" "}
                                                                        P
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {hasCoupon &&
                                                                couponType.map(
                                                                    (
                                                                        coupon
                                                                    ) => (
                                                                        <tr
                                                                            key={
                                                                                coupon.id
                                                                            }
                                                                        >
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                                {
                                                                                    coupon.coupon_name
                                                                                }
                                                                            </td>
                                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                                ₹{" "}
                                                                                {
                                                                                    coupon.coupon_points_hold
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {!hasMembership && (
                                            <div className="flex flex-col">
                                                <label className="text-sm font-medium text-gray-700 mb-2">
                                                    Select Membership Plan
                                                </label>
                                                <select
                                                    value={
                                                        selectMembership?.id ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        handleMembershipChange(
                                                            e.target.value
                                                        )
                                                    }
                                                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                                >
                                                    <option value="" disabled>
                                                        Select a plan
                                                    </option>

                                                    {membershipOptions.map(
                                                        (option) => (
                                                            <option
                                                                key={option.id}
                                                                value={
                                                                    option.id
                                                                }
                                                            >
                                                                {
                                                                    option.program_type
                                                                }
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        )}

                                        {!hasCoupon && (
                                            <div className="flex flex-col">
                                                <label className="text-sm font-medium text-gray-700 mb-2">
                                                    Select Coupons
                                                </label>
                                                <select
                                                    value={
                                                        selectCoupon?.id ||
                                                        "None"
                                                    }
                                                    onChange={(e) =>
                                                        handleCouponChange(
                                                            e.target.value
                                                        )
                                                    }
                                                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                                >
                                                    <option value="None">
                                                        Select a Coupon
                                                    </option>
                                                    {couponOptions.map(
                                                        (coupon) => (
                                                            <option
                                                                key={coupon.id}
                                                                value={
                                                                    coupon.id
                                                                }
                                                            >
                                                                {
                                                                    coupon.coupon_name
                                                                }
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        )}
                                    </div>

                                    {/* Points Input Fields */}
                                    {userExists &&
                                        (membershipType !== "None" ||
                                            hasCoupon) && (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                                                {membershipType !== "None" &&
                                                    membershipType !== "" && (
                                                        <div className="flex flex-col">
                                                            <label className="text-sm font-medium text-gray-700 mb-2">
                                                                Membership
                                                                Points
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                                                placeholder="Enter Points"
                                                                onChange={(e) =>
                                                                    setDeductedPoints(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    )}

                                                {hasCoupon && (
                                                    <div className="flex flex-col">
                                                        <label className="text-sm font-medium text-gray-700 mb-2">
                                                            Coupon Amount
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                                            placeholder="Enter Points"
                                                            onChange={(e) =>
                                                                setValueDeductedPoints(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    {/* Selected Membership and Coupons Table */}
                                    {(selectMembership ||
                                        selectedCoupons.length > 0) && (
                                        <div className="mt-6">
                                            <h4 className="text-md font-medium text-gray-700 mb-3">
                                                Selected Benefits
                                            </h4>
                                            <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                <table className="min-w-full divide-y divide-gray-200">
                                                    <thead className="bg-gray-100">
                                                        <tr>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Name
                                                            </th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Price
                                                            </th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                GST
                                                            </th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Sold By
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {selectMembership && (
                                                            <tr>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                    {
                                                                        selectMembership.program_type
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {selectMembership.gst ===
                                                                    "Inclusive"
                                                                        ? (
                                                                              selectMembership.price /
                                                                              1.18
                                                                          ).toFixed(
                                                                              2
                                                                          )
                                                                        : selectMembership.price ||
                                                                          0}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    <select
                                                                        className="border border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                        value={
                                                                            selectMembership.gst ||
                                                                            ""
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleMembershipGST(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        required
                                                                    >
                                                                        <option value="No GST">
                                                                            No
                                                                            GST
                                                                        </option>
                                                                        <option value="Inclusive">
                                                                            Inclusive
                                                                        </option>
                                                                        <option value="Exclusive">
                                                                            Exclusive
                                                                        </option>
                                                                    </select>
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    <div
                                                                        className="border border-gray-300 px-3 py-1 bg-white text-black rounded-lg cursor-pointer hover:bg-gray-50 transition"
                                                                        onClick={
                                                                            openMembershipStaffModal
                                                                        }
                                                                    >
                                                                        {membershipStaff &&
                                                                        membershipStaff.length >
                                                                            0 ? (
                                                                            Array.isArray(
                                                                                membershipStaff
                                                                            ) ? (
                                                                                membershipStaff
                                                                                    .map(
                                                                                        (
                                                                                            s
                                                                                        ) =>
                                                                                            s?.label
                                                                                                ? s.label
                                                                                                : s
                                                                                    )
                                                                                    .join(
                                                                                        ", "
                                                                                    )
                                                                            ) : (
                                                                                membershipStaff?.label ||
                                                                                membershipStaff
                                                                            )
                                                                        ) : (
                                                                            <span className="text-gray-500">
                                                                                Select
                                                                                Staff
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {selectedCoupons.length >
                                                            0 &&
                                                            selectedCoupons.map(
                                                                (
                                                                    coupon,
                                                                    index
                                                                ) => (
                                                                    <tr
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                            {
                                                                                coupon.coupon_name
                                                                            }
                                                                        </td>
                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                            {
                                                                                coupon.coupon_price
                                                                            }
                                                                        </td>
                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                            <select
                                                                                className="border border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                                value={
                                                                                    coupon.gst ||
                                                                                    ""
                                                                                }
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    handleCouponGSTChange(
                                                                                        index,
                                                                                        e
                                                                                            .target
                                                                                            .value
                                                                                    )
                                                                                }
                                                                                required
                                                                            >
                                                                                <option value="No GST">
                                                                                    No
                                                                                    GST
                                                                                </option>
                                                                                <option value="Inclusive">
                                                                                    Inclusive
                                                                                </option>
                                                                                <option value="Exclusive">
                                                                                    Exclusive
                                                                                </option>
                                                                            </select>
                                                                        </td>
                                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                            <div
                                                                                className="border border-gray-300 px-3 py-1 bg-white text-black rounded-lg cursor-pointer hover:bg-gray-50 transition"
                                                                                onClick={() =>
                                                                                    openCouponStaffModal(
                                                                                        index
                                                                                    )
                                                                                }
                                                                            >
                                                                                {couponStaff[
                                                                                    index
                                                                                ] &&
                                                                                couponStaff[
                                                                                    index
                                                                                ]
                                                                                    .length >
                                                                                    0 ? (
                                                                                    Array.isArray(
                                                                                        couponStaff[
                                                                                            index
                                                                                        ]
                                                                                    ) ? (
                                                                                        couponStaff[
                                                                                            index
                                                                                        ]
                                                                                            .map(
                                                                                                (
                                                                                                    s
                                                                                                ) =>
                                                                                                    s?.label
                                                                                                        ? s.label
                                                                                                        : s
                                                                                            )
                                                                                            .join(
                                                                                                ", "
                                                                                            )
                                                                                    ) : (
                                                                                        couponStaff[
                                                                                            index
                                                                                        ]
                                                                                            ?.label ||
                                                                                        couponStaff[
                                                                                            index
                                                                                        ]
                                                                                    )
                                                                                ) : (
                                                                                    <span className="text-gray-500">
                                                                                        Select
                                                                                        Staff
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : null}

                            {/* Comments Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="font-semibold text-lg text-gray-700 mb-4 flex items-center">
                                    <FaRegCommentDots
                                        className="mr-2 text-blue-400"
                                        aria-hidden="true"
                                    />
                                    Comments:
                                </h3>

                                <textarea
                                    placeholder="Enter any additional comments..."
                                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition min-h-[100px]"
                                    value={comments}
                                    onChange={(e) =>
                                        setComments(e.target.value)
                                    }
                                />

                                {isGST && (
                                    <div className="mt-4">
                                        <label className="text-sm font-medium text-gray-700 mb-2">
                                            GST Number
                                        </label>
                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition w-full"
                                            placeholder="Enter GST Number"
                                            required
                                            onChange={(e) =>
                                                setGSTNumber(e.target.value)
                                            }
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-center pt-4">
                                <button
                                    type="submit"
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-16 rounded-lg shadow-md transition flex items-center"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <CircularProgress
                                                size={20}
                                                color="inherit"
                                                className="mr-2"
                                            />
                                            Processing...
                                        </>
                                    ) : isEditMode ? (
                                        "Update Invoice"
                                    ) : (
                                        "Create Invoice"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                    {comboServiceModal.comboIndex !== null &&
                        comboServiceModal.serviceIndex !== null && (
                            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                                <div className="bg-white w-96 p-4 rounded-[2.5rem] shadow-lg">
                                    <h3 className="text-lg font-bold mb-4">
                                        Select Staff for Service
                                    </h3>
                                    <Select
                                        isMulti
                                        isSearchable={false}
                                        options={staffData}
                                        placeholder="Select Served By"
                                        className="rounded-[2.5rem] font-semibold"
                                        value={
                                            selectedList[
                                                comboServiceModal.comboIndex
                                            ]?.staff?.[
                                                comboServiceModal.serviceIndex
                                            ] || []
                                        }
                                        onChange={(selected) =>
                                            handleComboServiceStaffSelect(
                                                selected,
                                                comboServiceModal.comboIndex,
                                                comboServiceModal.serviceIndex
                                            )
                                        }
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderRadius: "2.5rem",
                                                padding: "2px",
                                            }),
                                        }}
                                    />

                                    <div className="flex justify-end mt-4">
                                        <button
                                            type="button"
                                            className="px-4 py-2 bg-gray-300 text-black rounded-[2.5rem] mr-2"
                                            onClick={closeComboServiceModal}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="px-4 py-2 bg-blue-500 text-white rounded-[2.5rem]"
                                            onClick={closeComboServiceModal}
                                        >
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    {/* Membership Staff Selection Modal */}
                    {isMembershipStaffModalOpen && (
                        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white w-96 p-4 rounded-[2.5rem] shadow-lg">
                                <h3 className="text-lg font-bold mb-4">
                                    Select Staff for Membership
                                </h3>
                                <Select
                                    isMulti
                                    isSearchable={false}
                                    options={staffData}
                                    placeholder="Select Staff"
                                    className="rounded-[2.5rem] font-semibold"
                                    value={membershipStaff || []}
                                    onChange={handleMembershipStaffSelect}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderRadius: "2.5rem",
                                            padding: "2px",
                                        }),
                                    }}
                                />

                                <div className="flex justify-end mt-4">
                                    <button
                                        type="button"
                                        className="px-4 py-2 bg-gray-300 text-black rounded-[2.5rem] mr-2"
                                        onClick={closeMembershipStaffModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="px-4 py-2 bg-blue-500 text-white rounded-[2.5rem]"
                                        onClick={closeMembershipStaffModal}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Coupon Staff Selection Modal */}
                    {isCouponStaffModalOpen && selectedCouponIndex !== null && (
                        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white w-96 p-4 rounded-[2.5rem] shadow-lg">
                                <h3 className="text-lg font-bold mb-4">
                                    Select Staff for{" "}
                                    {
                                        selectedCoupons[selectedCouponIndex]
                                            ?.coupon_name
                                    }
                                </h3>
                                <Select
                                    isMulti
                                    isSearchable={false}
                                    options={staffData}
                                    placeholder="Select Staff"
                                    className="rounded-[2.5rem] font-semibold"
                                    value={
                                        couponStaff[selectedCouponIndex] || []
                                    }
                                    onChange={(selected) =>
                                        handleCouponStaffSelect(
                                            selected,
                                            selectedCouponIndex
                                        )
                                    }
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderRadius: "2.5rem",
                                            padding: "2px",
                                        }),
                                    }}
                                />

                                <div className="flex justify-end mt-4">
                                    <button
                                        type="button"
                                        className="px-4 py-2 bg-gray-300 text-black rounded-[2.5rem] mr-2"
                                        onClick={closeCouponStaffModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="px-4 py-2 bg-blue-500 text-white rounded-[2.5rem]"
                                        onClick={closeCouponStaffModal}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default GenerateInvoice;
